module.exports = __webpack_public_path__ + "img/resized-APP-0011-2.6315fb02.png";